import React from 'react';
import { Award } from 'lucide-react';
import { Button, RobbieMark } from '../../ui';

interface RecommendationEmptyStateProps {
    readOnly: boolean;
    estimateOnly: boolean;
    onGenerate: () => void;
}

const RecommendationEmptyState: React.FC<RecommendationEmptyStateProps> = ({ readOnly, estimateOnly, onGenerate }) => (
    <div className="flex flex-col items-center gap-s4 rounded-card border border-line bg-surface px-s6 py-[44px] text-center">
        <RobbieMark size="lg" aria-label="Robbie" />
        <div>
            <h3 className="m-0 text-card-header text-ink">
                {readOnly ? 'No award recommendation yet' : 'Ready to review your quotes'}
            </h3>
            <p className="m-0 mt-s1 max-w-[480px] text-body-sm text-ink-secondary">
                {readOnly
                    ? "I haven't put an award plan together for this RFQ yet — that's the owner's to start."
                    : "I'll analyze supplier conversations, quotes, and your priorities, then propose an award split — which you can adjust supplier by supplier before confirming."}
            </p>
        </div>
        {!readOnly && (
            <Button size="lg" iconLeft={<Award />} onClick={onGenerate}>
                {estimateOnly ? 'Generate estimate-based recommendation' : 'Generate award recommendation'}
            </Button>
        )}
    </div>
);

export default RecommendationEmptyState;
